<template>
  <div
    v-if="items && items.length"
    id="usp"
    data-testid="sbx-pcc_usp"
    :style="cssColors"
    :class="[
      `usp`,
      {
        has_title: this.title,
        'usp--slim': this.isSlimUsp,
      },
    ]"
  >
    <div :class="[`usp__uspTitle`, `align-${this.align}`]" data-testid="sbx-pcc_uspTitle" v-if="title">
      {{ title }}
    </div>
    <div
      :class="[
        `usp__list`,
        { scrollable: this.mobileScroll == 'true' && isMobile },
        { stack: this.mobileScroll == 'false' && isMobile },
        `${this.oddGrid}`,
      ]"
      data-testid="sbx-pcc_usp_list"
    >
      <div class="usp__item" v-for="(item, index) in this.items" :key="`usp__item-${index}`">
        <div :class="[`usp__itemIcon`, `${getAlignClass}`]">
          <i :data-testid="`sbx-pcc_usp-icon-${index}`" :class="`si ${item.icon}`"></i>
        </div>
        <div class="usp__itemText">
          <div :class="[`usp__itemTitle`, `${getAlignClass}`, { bold: item.subtitle }]">{{ item.title }}</div>
          <div v-if="item.subtitle" :class="[`usp__itemSubtitle`, `${getAlignClass}`]">{{ item.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { usp } from './index.js';
import { collectionBlack } from '@/SharedFe/scss/brand.module.scss';

export default {
  name: 'usp',
  props: {
    ...usp.propTypes,
    screenPx: {
      type: Number,
    },
  },
  computed: {
    cssColors() {
      return {
        '--fontColor': this.fontColor ? this.fontColor
          : collectionBlack,
        '--iconColor': this.iconColor ? this.iconColor
          : collectionBlack,
      };
    },
    getAlignClass() {
      return this.align ? 'align-' + this.align : '';
    },
    isSlimUsp() {
      return this.isSlim === 'true';
    },
    isMobile() {
      return this.screenPx <= 850;
    },
    oddGrid() {
      const list_odd = this.items.length === 4 || this.items.length === 2 ? ' list_odd' : '';
      return list_odd;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/SharedFe/scss/variables.scss';
@import '@/SharedFe/scss/smartbox-icons.scss';

$medium-up: 'only screen and (min-width: 768px)';
$small-tablet: 'only screen and (min-width: 768px) and (max-width: 850px)';

$fontColor: var(--fontColor);
$iconColor: var(--iconColor);

.usp {
  padding: rem-calc(24 0);
  margin: 0 auto;
  max-width: 80rem;
  width: 100%;
  color: $collection-superdark-grey;
  @media #{$desktop-up} {
    padding: rem-calc(32 0);
  }

  &__uspTitle {
    font-size: rem-calc(24);
    font-family: $brand-font-medium;
    line-height: rem-calc(24);
    padding: rem-calc(0 10 16);
    @media #{$mobile-up} {
      padding: rem-calc(0 15 24);
    }
  }

  .align-center {
    text-align: center;
  }

  .align-left {
    text-align: left;

    & .si {
      justify-content: left;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: rem-calc(5);
    padding: 0;
    justify-content: center;
    align-items: flex-start;
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    gap: rem-calc(8);
    flex-shrink: 0;
    padding: rem-calc(16 5);
    box-sizing: border-box;
  }

  &__itemIcon {
    color: $iconColor;

    & .si {
      font-size: rem-calc(40);
      height: rem-calc(40);
      @media #{$desktop-up} {
        font-size: rem-calc(48);
        height: rem-calc(48);
      }
      display: flex;
      justify-content: center;
      align-items: center;

      &.si-usp-free-delivery {
        font-size: rem-calc(32);
      }

      &.si-usp-validity {
        font-size: rem-calc(32);
      }

      &.si-usp-locations {
        font-size: rem-calc(38);
      }

      &.si-box,
      &.si-check-circle {
        font-size: rem-calc(54);
      }

      @media #{$mobile-up} {
        font-size: rem-calc(48);
        height: rem-calc(48);
        &.si-usp-free-delivery {
          font-size: rem-calc(36);
        }
        &.si-usp-validity {
          font-size: rem-calc(36);
        }
        &.si-usp-locations {
          font-size: rem-calc(38);
        }
        &.si-box {
          font-size: rem-calc(70);
        }
        &.si-check-circle {
          font-size: rem-calc(64);
        }
      }
    }
  }

  &__itemTitle {
    flex: 1 0 auto;
    font-family: $brand-font-regular;
    color: $fontColor;
    font-size: rem-calc(14);
    line-height: rem-calc(18);
    font-family: $brand-font-medium;
  }

  &__itemSubtitle {
    font-family: $brand-font-regular;
    color: $fontColor;
    font-size: rem-calc(11);
    line-height: rem-calc(18);
    @media #{$mobile-up} {
      font-size: rem-calc(13);
    }
  }

  //mobile scroll
  &__list.scrollable {
    max-width: 100%;
    overflow-x: scroll;
    justify-content: flex-start;
    -ms-overflow-style: none;
    white-space: break-spaces;
    scrollbar-width: none;
    flex-wrap: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }

    .usp__item {
      max-width: 38%;
      flex-grow: 1;
      min-width: rem-calc(140);
      @media screen and (min-width: 484px) {
        max-width: 27%;
        min-width: rem-calc(140);
      }
    }
  }

  &__list.stack {
    .usp__item {
      min-width: calc(33.3% - 5px);
    }

    &.list_odd {
      .usp__item {
        min-width: calc(50% - 5px);
      }
    }
  }

  /* Slim version */
  &--slim {
    padding: rem-calc(24 16);
    overflow: hidden;
    width: auto;
    justify-content: space-evenly;

    @media #{$desktop-up} {
      padding: rem-calc(24 16);
    }

    .usp__list {
      justify-content: space-between;

      &.scrollable {
        flex-shrink: 0;

        .usp__item {
          padding: 0 1rem;
          min-width: fit-content;
          max-width: max-content;
          @media #{$medium-up} {
            max-width: unset;
            min-width: unset;
          }
          @media #{$small-tablet} {
            min-width: fit-content;
            max-width: max-content;
          }
        }
      }
    }

    .usp__item {
      flex-direction: row;
      align-items: center;
      justify-content: left;
      gap: rem-calc(8);
      padding: 0;
      @media #{$small-tablet} {
        width: min(calc(16.66% - 8px), 145px);
        flex: 0 1 auto;
      }
      @media #{$desktop-up} {
        width: auto;
        flex: 1;
      }
    }

    .usp__itemIcon {
      font-size: rem-calc(24);
      height: rem-calc(24);
      @media #{$mobile-up} {
        font-size: rem-calc(32);
        height: rem-calc(32);
      }

      .si {
        height: rem-calc(24);
        width: rem-calc(24);
        font-size: rem-calc(24);
        position: relative;

        &:before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &.si-usp-free-delivery {
          font-size: rem-calc(20);
        }

        &.si-usp-validity {
          font-size: rem-calc(20);
        }

        &.si-usp-locations {
          font-size: rem-calc(18);
        }

        &.si-box {
          font-size: rem-calc(34);
        }

        &.si-check-circle {
          font-size: rem-calc(34);
        }

        @media #{$mobile-up} {
          height: rem-calc(32);
          width: rem-calc(32);
          font-size: rem-calc(32);
          &.si-usp-free-delivery {
            font-size: rem-calc(24);
          }
          &.si-usp-validity {
            font-size: rem-calc(26);
          }
          &.si-usp-locations {
            font-size: rem-calc(26);
          }
          &.si-box {
            font-size: rem-calc(48);
          }
          &.si-check-circle {
            font-size: rem-calc(46);
          }
        }
      }
    }

    .usp__itemTitle,
    .usp__itemSubtitle {
      font-size: rem-calc(12);
      line-height: rem-calc(20);
      @media #{$mobile-up} {
        font-size: rem-calc(14);
      }
    }
  }
}
</style>
